import { useMemo } from 'react'
import { Line, LineChart, ResponsiveContainer, YAxis } from 'recharts'

interface Props {
  data: number[]
  color?: string
  height?: number
}

export function Sparkline({
  data,
  color = 'currentColor',
  height = 24
}: Props) {
  const chartData = useMemo(() => data.map((v, i) => ({ i, v })), [data])
  if (!data.length) return null
  const max = Math.max(...data, 1)
  return (
    <div style={{ height }} className="w-full text-primary/70">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{ top: 2, right: 0, bottom: 2, left: 0 }}
        >
          <YAxis hide domain={[0, max]} />
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive
            animationDuration={500}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
